// Constantes del módulo Pre-Visit Planning (Módulo D — BillingV2).

/** Estados del prep packet por cita. */
export const PREP_STATUS = {
  PENDING: "pending",
  READY: "ready",
  REVIEWED: "reviewed",
};

/** Mapa estado → tono semántico + label (siempre texto + color, nunca solo color). */
export const PREP_STATUS_META = {
  [PREP_STATUS.PENDING]: { tone: "warn", label: "Prep pending" },
  [PREP_STATUS.READY]: { tone: "info", label: "Prep ready" },
  [PREP_STATUS.REVIEWED]: { tone: "ok", label: "Reviewed by provider" },
};

/** Claves del selector de fecha del shell. */
export const DATE_KEYS = {
  TODAY: "today",
  TOMORROW: "tomorrow",
};

export const DATE_OPTIONS = [
  { value: DATE_KEYS.TODAY, label: "Today" },
  { value: DATE_KEYS.TOMORROW, label: "Tomorrow" },
];

/** Prioridad de care gap → tono. */
export const GAP_PRIORITY_TONE = {
  high: "crit",
  medium: "warn",
  low: "muted",
};
